import { Component, EventEmitter, Output, ElementRef, AfterContentInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'swb-modal',
  exportAs: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements AfterContentInit {
  @Output() modalClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() modalExecute: EventEmitter<string> = new EventEmitter<string>();
  public margin = 0;

  @HostListener('document:keyup', ['$event'])

  onKeyUp(ev: KeyboardEvent) {
    switch (ev.key) {
      case 'Escape':
        this.closeModal(ev);
        break;
      case 'Enter':
        // submit
        break;
      default:
        break;
    }
  }

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _elementRef: ElementRef
  ) { }

  closeModal($event: any): void {

    this._router.navigate([{ outlets: { modal: null }, event: $event }], {
      relativeTo: this._route.parent
    });

    this.modalClose.next($event);
  }

  execute() {
    // construct url
    if (this._route.snapshot.data.apiUri) {
      const resource = this._route.snapshot.data.apiUri
        + '/' + this._route.snapshot.url[1].path;
      this.modalExecute.next(resource);
    } else {
      this.closeModal('');
    }
  }

  ngAfterContentInit() {
    // set correct margin for vertical centering
    const modalHeight = this._elementRef.nativeElement.querySelector('.modal__content').offsetHeight;
    this.margin = ((modalHeight + 60) / 2 * -1);
  }

}
